module.exports = __webpack_public_path__ + "img/img-pragmaticplay-d.f9b7465b.png";